import { Route } from 'react-router-dom';

export default function PublicRoute({ path, component }) {
    return (
        <Route exact path={path}>
            {component}
        </Route>
    )
}